<label class="toggle-switch" [ngClass]="{'checked': checked$ | async }" [ngStyle]="{'flex-direction': direction === 'left'? 'row':'row-reverse'}">
    <span class="label"><ng-content></ng-content></span>
    <input type="checkbox" [attr.checked]="initialCheckedValue || null" #toggle>
    <div class="track"></div>
</label>